export default __webpack_public_path__ + "static/defAward-a001be9827f1c973dfcd20f24a624dcf.jpg";